import { useEffect, useState } from 'react'

export function IntroScreen({ onComplete }: { onComplete: () => void }) {
  const [fading, setFading] = useState(false)

  useEffect(() => {
    // Start fading out after 1.3 seconds
    const fadeTimer = setTimeout(() => {
      setFading(true)
    }, 1300)

    // Complete the intro and unmount after 1.8 seconds
    const completeTimer = setTimeout(() => {
      onComplete()
    }, 1800)

    return () => {
      clearTimeout(fadeTimer)
      clearTimeout(completeTimer)
    }
  }, [onComplete])

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[var(--color-surface)] select-none transition-opacity duration-500 ease-in-out ${
        fading ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-4 text-center">
        {/* Animated Icon Container */}
        <div className="relative h-24 w-24 animate-scale-bounce">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            className="h-full w-full select-none"
            aria-hidden="true"
          >
            <defs>
              <filter id="glow" x="-25%" y="-25%" width="150%" height="150%">
                <feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#000000" floodOpacity="0.18" />
              </filter>
            </defs>
            {/* Soft background shape */}
            <rect width="128" height="128" rx="28" fill="#3a3740" filter="url(#glow)" />
            {/* The 3 calendar-style list lines from favicon.svg */}
            <path
              d="M36 40h56M36 64h56M36 88h36"
              stroke="#d8d4dc"
              strokeWidth="9"
              strokeLinecap="round"
              className="animate-draw-lines"
            />
          </svg>
        </div>

        {/* Animated Brand Name */}
        <h1 className="mt-2 text-3xl font-bold tracking-widest text-[var(--color-ink)] animate-fade-in-tracking">
          Thana
        </h1>
      </div>
    </div>
  )
}
